module.exports = __webpack_public_path__ + "img/guide_2_3.e7adec4f.svg";